import { clearAuthTokens } from '../helpers/authentication'

export function handleAuthError(error) {
  if (error && /token|jws/i.test(error.message)) {
    console.warn('Token error. Tokens removed.')
    clearAuthTokens()
  }
}
